var MessageUserType = /* @__PURE__ */ ((MessageUserType2) => {
  MessageUserType2["CUSTOMER"] = "CUSTOMER";
  MessageUserType2["AGENT"] = "AGENT";
  MessageUserType2["SYSTEM"] = "SYSTEM";
  return MessageUserType2;
})(MessageUserType || {});
export {
  MessageUserType as M
};
